import type { FC } from 'react';
import { Collapse, useTheme } from '@mui/material';

import { MainWithFooterTemplate } from '../../../molecules/MainWithFooterTemplate/MainWithFooterTemplate';
import { ContentWrapper } from '../ProfileManager.styles';

import { useDriverFeedbackContext } from './DriverFeedbackProvider';
import { NoRatingBlock } from './NoRatingBlock';
import { RatingBlock } from './RatingBlock';

export const DriverReviewPage: FC = () => {
	const { palette } = useTheme();

	const { averageRating, countOfFeedbacks } = useDriverFeedbackContext();

	const hasRating = countOfFeedbacks > 0;

	return (
		<MainWithFooterTemplate
			content={
				<ContentWrapper
					sx={{ backgroundColor: palette.primary.light, maxWidth: '100%' }}
				>
					<Collapse in={!hasRating}>
						<NoRatingBlock />
					</Collapse>
					<Collapse in={hasRating}>
						<RatingBlock
							countOfReviews={countOfFeedbacks}
							rating={averageRating}
						/>
						{/*
								TODO: Driver rating second iteration
								<ReviewsTable />
								<ReviewsTableStepper />
							*/}
					</Collapse>
				</ContentWrapper>
			}
		/>
	);
};
